// The 422 the monolith renders when a message would go to an applicant who
// opted out of messages from the sending number. Nothing was sent; Hire's
// message says why.

// Mirrored against the OptedOutError rescue in
// ApiSelfServe::V2::Applicants::MessagesController in apps/hire through
// tools/contract-mirrors/mirrors.json.
export const NUMBER_OPTED_OUT_CODE = 'messages.number_opted_out';

// What the axios interceptor rejects with when the response body carries
// `code: 'messages.number_opted_out'`.
export interface NumberOptedOutRefusal {
  code: typeof NUMBER_OPTED_OUT_CODE;
  message: string;
}

export function isNumberOptedOutRefusal(
  value: unknown,
): value is NumberOptedOutRefusal {
  if (value == null || typeof value !== 'object') {
    return false;
  }
  const candidate = value as { code?: unknown; message?: unknown };
  return (
    candidate.code === NUMBER_OPTED_OUT_CODE &&
    typeof candidate.message === 'string'
  );
}
